import React from 'react';

function fmt(value, digits = 2, suffix = '') {
  if (value == null || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(digits)}${suffix}` : '—';
}

function signedBp(value) {
  if (value == null || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number) ? `${number > 0 ? '+' : ''}${number.toFixed(1)}bp` : '—';
}

const ACTION_LABELS = { buy: '买入', add: '加仓', hold: '持有', reduce: '减仓' };

export default function RiskAdjustedPerformancePanel({ profile }) {
  if (!profile?.windows?.length) return null;
  return (
    <div className="risk-adjusted-panel">
      <div className="risk-adjusted-head">
        <div><span>RISK-ADJUSTED FACTS</span><strong>收益是否值得承担这些波动</strong></div>
        <p>{profile.summary}</p>
      </div>
      <div className="risk-adjusted-table-wrap">
        <table className="risk-adjusted-table">
          <thead><tr><th>观察窗口</th><th>累计收益</th><th>最大回撤</th><th>日波动</th><th>下行风险</th><th>收益/回撤</th><th>日均收益/波动</th><th>日均收益/下行风险</th><th>事实结论</th></tr></thead>
          <tbody>{profile.windows.map((item) => (
            <tr key={item.key}>
              <td><strong>{item.label}</strong><small>{item.available ? `${item.start_date} 至 ${item.end_date}` : `${item.sample_size || 0}个有效点`}</small></td>
              {item.available ? <>
                <td className={Number(item.cumulative_return_bp) >= 0 ? 'tone-positive' : 'tone-negative'}>{signedBp(item.cumulative_return_bp)}</td>
                <td>{fmt(item.max_drawdown_bp, 1, 'bp')}</td>
                <td>{fmt(item.volatility_bp, 2, 'bp')}</td>
                <td>{fmt(item.downside_risk_bp, 2, 'bp')}</td>
                <td>{fmt(item.return_drawdown_ratio, 2)}</td>
                <td>{fmt(item.return_volatility_ratio, 2)}</td>
                <td>{fmt(item.return_downside_ratio, 2)}</td>
                <td>{item.fact}</td>
              </> : <td colSpan="8" className="risk-adjusted-missing">{item.reason}</td>}
            </tr>
          ))}</tbody>
        </table>
      </div>
      {profile.anomaly_caution ? <p className="risk-adjusted-caution">{profile.anomaly_caution}</p> : null}
      <div className="risk-adjusted-actions">
        {Object.entries(ACTION_LABELS).map(([key, label]) => <div key={key}><span>{label}</span><p>{profile.action_use?.[key]}</p></div>)}
      </div>
      <p className="risk-adjusted-method">{profile.method}</p>
    </div>
  );
}
